const actions = {
    GET_NETWORK_BY_DEALER_PORTIN_MAPPING: 'GET_NETWORK_BY_DEALER_PORTIN_MAPPING',
    GET_NETWORK_BY_DEALER_PORTIN_MAPPING_SUCCESS: 'GET_NETWORK_BY_DEALER_PORTIN_MAPPING_SUCCESS',
    GET_NETWORK_BY_DEALER_PORTIN_MAPPING_FAILED: 'GET_NETWORK_BY_DEALER_PORTIN_MAPPING_FAILED',

    CREATE_PORTIN_ACTIVATION: 'CREATE_PORTIN_ACTIVATION',
    CREATE_PORTIN_ACTIVATION_SUCCESS: 'CREATE_PORTIN_ACTIVATION_SUCCESS',
    CREATE_PORTIN_ACTIVATION_FAILED: 'CREATE_PORTIN_ACTIVATION_FAILED',

    GET_BULK_PORTIN_ACTIVATION: 'GET_BULK_PORTIN_ACTIVATION',
    GET_BULK_PORTIN_ACTIVATION_SUCCESS: 'GET_BULK_PORTIN_ACTIVATION_SUCCESS',
    GET_BULK_PORTIN_ACTIVATION_FAILED: 'GET_BULK_PORTIN_ACTIVATION_FAILED',

    RESET_MESSAGES: 'RESET_MESSAGES',
    RESET_DATA: 'RESET_DATA',

    CHECK_SERIAL_NUMBER_BY_BATCH: 'CHECK_SERIAL_NUMBER_BY_BATCH',
    CHECK_SERIAL_NUMBER_BY_BATCH_SUCCESS: 'CHECK_SERIAL_NUMBER_BY_BATCH_SUCCESS',
    CHECK_SERIAL_NUMBER_BY_BATCH_FAILED: 'CHECK_SERIAL_NUMBER_BY_BATCH_FAILED',

    UPDATE_MANUAL_PORTIN_ACTIVATION: 'UPDATE_MANUAL_PORTIN_ACTIVATION',
    UPDATE_MANUAL_PORTIN_ACTIVATION_SUCCESS: 'UPDATE_MANUAL_PORTIN_ACTIVATION_SUCCESS',
    UPDATE_MANUAL_PORTIN_ACTIVATION_FAILED: 'UPDATE_MANUAL_PORTIN_ACTIVATION_FAILED',

    RESET_SUCCESS_MESSAGES: 'RESET_SUCCESS_MESSAGES',

    UPDATE_PORTIN_STATUS: "UPDATE_PORTIN_STATUS",
    UPDATE_PORTIN_STATUS_SUCCESS: "UPDATE_PORTIN_STATUS_SUCCESS",
    UPDATE_PORTIN_STATUS_FAILED: "UPDATE_PORTIN_STATUS_FAILED",

    UPDATE_PORTIN_ACTIVATION_BULK_STATUS: "UPDATE_PORTIN_ACTIVATION_BULK_STATUS",
    UPDATE_PORTIN_ACTIVATION_BULK_STATUS_SUCCESS: "UPDATE_PORTIN_ACTIVATION_BULK_STATUS_SUCCESS",
    UPDATE_PORTIN_ACTIVATION_BULK_STATUS_FAILED: "UPDATE_PORTIN_ACTIVATION_BULK_STATUS_FAILED",

    GET_BULK_PORTIN_ACTIVATION_LIST: 'GET_BULK_PORTIN_ACTIVATION_LIST',
    GET_BULK_PORTIN_ACTIVATION_LIST_SUCCESS: 'GET_BULK_PORTIN_ACTIVATION_LIST_SUCCESS',
    GET_BULK_PORTIN_ACTIVATION_LIST_FAILED: 'GET_BULK_PORTIN_ACTIVATION_LIST_FAILED',

    GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID: 'GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID',
    GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID_SUCCESS: 'GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID_SUCCESS',
    GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID_FAILED: 'GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID_FAILED',

    OPEN_ADD_PORTIN_MODAL: 'OPEN_ADD_PORTIN_MODAL',
    CLOSE_ADD_PORTIN_MODAL: 'CLOSE_ADD_PORTIN_MODAL',

    GET_PORTIN_ACTIVATIONS: 'GET_PORTIN_ACTIVATIONS',
    GET_PORTIN_ACTIVATIONS_SUCCESS: 'GET_PORTIN_ACTIVATIONS_SUCCESS',
    GET_PORTIN_ACTIVATIONS_FAILED: 'GET_PORTIN_ACTIVATIONS_FAILED',

    GET_INCOMPLETE_PORTIN_COUNT: "GET_INCOMPLETE_PORTIN_COUNT",
    GET_INCOMPLETE_PORTIN_COUNT_SUCCESSFUL: "GET_INCOMPLETE_PORTIN_COUNT_SUCCESSFUL",
    GET_INCOMPLETE_PORTIN_COUNT_FAILED: "GET_INCOMPLETE_PORTIN_COUNT_FAILED",

    LOCK_PORTIN_ACTIVATION: 'LOCK_PORTIN_ACTIVATION',
    LOCK_PORTIN_ACTIVATION_SUCCESS: 'LOCK_PORTIN_ACTIVATION_SUCCESS',
    LOCK_PORTIN_ACTIVATION_FAILED: 'LOCK_PORTIN_ACTIVATION_FAILED',

    UNLOCK_PORTIN_ACTIVATION: 'UNLOCK_PORTIN_ACTIVATION',
    UNLOCK_PORTIN_ACTIVATION_SUCCESS: 'UNLOCK_PORTIN_ACTIVATION_SUCCESS',
    UNLOCK_PORTIN_ACTIVATION_FAILED: 'UNLOCK_PORTIN_ACTIVATION_FAILED',

    CANCEL_PORT_ACTIVATION: 'CANCEL_PORT_ACTIVATION',
    CANCEL_PORT_ACTIVATION_SUCCESS: 'CANCEL_PORT_ACTIVATION_SUCCESS',
    CANCEL_PORT_ACTIVATION_FAILED: 'CANCEL_PORT_ACTIVATION_FAILED',

    COMPLETE_PORTIN_ACTIVATION: 'COMPLETE_PORTIN_ACTIVATION',
    COMPLETE_PORTIN_ACTIVATION_SUCCESS: 'COMPLETE_PORTIN_ACTIVATION_SUCCESS',
    COMPLETE_PORTIN_ACTIVATION_FAILED: 'COMPLETE_PORTIN_ACTIVATION_FAILED',

    REFUND_PORTIN_ACTIVATION: 'REFUND_PORTIN_ACTIVATION',
    REFUND_PORTIN_ACTIVATION_SUCCESS: 'REFUND_PORTIN_ACTIVATION_SUCCESS',
    REFUND_PORTIN_ACTIVATION_FAILED: 'REFUND_PORTIN_ACTIVATION_FAILED',

    refundPortActivation: (data) => ({
        type: actions.REFUND_PORTIN_ACTIVATION,
        payload: { data }
    }),
    refundPortActivationSuccess: (message) => ({
        type: actions.REFUND_PORTIN_ACTIVATION_SUCCESS,
        payload: { message }
    }),
    refundPortActivationFailed: (error) => ({
        type: actions.REFUND_PORTIN_ACTIVATION_FAILED,
        payload: { error }
    }),

    completePortinActivation: (data) => ({
        type: actions.COMPLETE_PORTIN_ACTIVATION,
        payload: { data }
    }),
    completePortinActivationSuccess: (message) => ({
        type: actions.COMPLETE_PORTIN_ACTIVATION_SUCCESS,
        payload: { message }
    }),
    completePortinActivationFailed: (error) => ({
        type: actions.COMPLETE_PORTIN_ACTIVATION_FAILED,
        payload: { error }
    }),

    cancelkPortActivation: (data) => ({
        type: actions.CANCEL_PORT_ACTIVATION,
        payload: { data }
    }),
    cancelkPortActivationSuccess: (message) => ({
        type: actions.CANCEL_PORT_ACTIVATION_SUCCESS,
        payload: { message }
    }),
    cancelkPortActivationFailed: (error) => ({
        type: actions.CANCEL_PORT_ACTIVATION_FAILED,
        payload: { error }
    }),

    unlockPortinActivation: (data, searchData) => ({
        type: actions.UNLOCK_PORTIN_ACTIVATION,
        payload: { data, searchData }
    }),
    unlockPortinActivationSuccess: (message) => ({
        type: actions.UNLOCK_PORTIN_ACTIVATION_SUCCESS,
        payload: { message }
    }),
    unlockPortinActivationFailed: (error) => ({
        type: actions.UNLOCK_PORTIN_ACTIVATION_FAILED,
        payload: { error }
    }),

    lockPortinActivation: (data, searchData) => ({
        type: actions.LOCK_PORTIN_ACTIVATION,
        payload: { data, searchData }
    }),
    lockPortinActivationSuccess: (message) => ({
        type: actions.LOCK_PORTIN_ACTIVATION_SUCCESS,
        payload: { message }
    }),
    lockPortinActivationFailed: (error) => ({
        type: actions.LOCK_PORTIN_ACTIVATION_FAILED,
        payload: { error }
    }),

    getIncompleteCount: () => ({
        type: actions.GET_INCOMPLETE_PORTIN_COUNT,
    }),
    getIncompleteCountSuccess: (result) => ({
        type: actions.GET_INCOMPLETE_PORTIN_COUNT_SUCCESSFUL,
        result
    }),
    getIncompleteCountFailed: (error) => ({
        type: actions.GET_INCOMPLETE_PORTIN_COUNT_FAILED,
        error
    }),

    getPortinActivations: (data) => ({
        type: actions.GET_PORTIN_ACTIVATIONS,
        payload: { data }
    }),
    getPortinActivationsSuccess: (data) => ({
        type: actions.GET_PORTIN_ACTIVATIONS_SUCCESS,
        payload: { data }
    }),
    getPortinActivationsFailed: (error) => ({
        type: actions.GET_PORTIN_ACTIVATIONS_FAILED,
        payload: { error }
    }),

    openAddPortinModal: () => ({
        type: actions.OPEN_ADD_PORTIN_MODAL,
    }),
    closeAddPortinModal: () => ({
        type: actions.CLOSE_ADD_PORTIN_MODAL,
    }),

    getBulkPortinActivationListByBatchID: (data) => ({
        type: actions.GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID,
        payload: { data }
    }),
    getBulkPortinActivationListByBatchIDSuccess: (result) => ({
        type: actions.GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID_SUCCESS,
        result
    }),
    getBulkPortinActivationListByBatchIDFailed: (error) => ({
        type: actions.GET_BULK_PORTIN_ACTIVATION_LIST_BY_BATCHID_FAILED,
        error
    }),

    getBulkPortinActivationList: () => ({
        type: actions.GET_BULK_PORTIN_ACTIVATION_LIST,
    }),
    getBulkPortinActivationListSuccess: (result) => ({
        type: actions.GET_BULK_PORTIN_ACTIVATION_LIST_SUCCESS,
        result
    }),
    getBulkPortinActivationListFailed: (error) => ({
        type: actions.GET_BULK_PORTIN_ACTIVATION_LIST_FAILED,
        error
    }),

    updatePortinActivationBulkStatus: (searchData) => ({
        type: actions.UPDATE_PORTIN_ACTIVATION_BULK_STATUS,
        payload: { searchData }
    }),
    updatePortinActivationBulkStatusSuccess: (message) => ({
        type: actions.UPDATE_PORTIN_ACTIVATION_BULK_STATUS_SUCCESS,
        message
    }),
    updatePortinActivationBulkStatusFailed: (error) => ({
        type: actions.UPDATE_PORTIN_ACTIVATION_BULK_STATUS_FAILED,
        error
    }),

    updatePortinStatus: (updateData, data) => ({
        type: actions.UPDATE_PORTIN_STATUS,
        payload: { updateData, data }
    }),
    updatePortinStatusSuccess: (message, activationId) => ({
        type: actions.UPDATE_PORTIN_STATUS_SUCCESS,
        message,
        activationId
    }),
    updatePortinStatusFailed: (error, activationId) => ({
        type: actions.UPDATE_PORTIN_STATUS_FAILED,
        error,
        activationId
    }),

    resetData: () => ({
        type: actions.RESET_DATA,
    }),

    resetMessage: () => ({
        type: actions.RESET_MESSAGES,
    }),

    getNetworkByDealerPortinMapping: () => ({
        type: actions.GET_NETWORK_BY_DEALER_PORTIN_MAPPING,
    }),
    getNetworkByDealerPortinMappingSuccess: (result) => ({
        type: actions.GET_NETWORK_BY_DEALER_PORTIN_MAPPING_SUCCESS,
        result
    }),
    getNetworkByDealerPortinMappingFailed: (error) => ({
        type: actions.GET_NETWORK_BY_DEALER_PORTIN_MAPPING_FAILED,
        error
    }),

    createPortinActivation: (data, search) => ({
        type: actions.CREATE_PORTIN_ACTIVATION,
        data, search
    }),
    createPortinActivationSuccess: (message) => ({
        type: actions.CREATE_PORTIN_ACTIVATION_SUCCESS,
        message
    }),
    createPortinActivationFailed: (error) => ({
        type: actions.CREATE_PORTIN_ACTIVATION_FAILED,
        error
    }),

    getBulkPortinActivation: (data,) => ({
        type: actions.GET_BULK_PORTIN_ACTIVATION,
        payload: { data }
    }),
    getBulkPortinActivationSuccess: (result) => ({
        type: actions.GET_BULK_PORTIN_ACTIVATION_SUCCESS,
        result
    }),
    getBulkPortinActivationFailed: (error) => ({
        type: actions.GET_BULK_PORTIN_ACTIVATION_FAILED,
        error
    }),

    checkSerialNumberByBatch: (data) => ({
        type: actions.CHECK_SERIAL_NUMBER_BY_BATCH,
        payload: { data }
    }),
    checkSerialNumberByBatchSuccess: (result) => ({
        type: actions.CHECK_SERIAL_NUMBER_BY_BATCH_SUCCESS,
        result
    }),
    checkSerialNumberByBatchFailed: (error) => ({
        type: actions.CHECK_SERIAL_NUMBER_BY_BATCH_FAILED,
        error
    }),

    updateManualPortinActivation: (data, search) => ({
        type: actions.UPDATE_MANUAL_PORTIN_ACTIVATION,
        data, search
    }),
    updateManualPortinActivationSuccess: (message) => ({
        type: actions.UPDATE_MANUAL_PORTIN_ACTIVATION_SUCCESS,
        message
    }),
    updateManualPortinActivationFailed: (error) => ({
        type: actions.UPDATE_MANUAL_PORTIN_ACTIVATION_FAILED,
        error
    }),
    resetSucessMessage: () => ({
        type: actions.RESET_SUCCESS_MESSAGES,
    }),


};
export default actions;